"use strict";
/*!
Copyright (C) 2020 Evolved Binary

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.createNode = createNode;
exports.createCDataSectionNode = createCDataSectionNode;
const lwdita_ast_1 = require("@evolvedbinary/lwdita-ast");
const lwdita_ast_2 = require("@evolvedbinary/lwdita-ast");
const lwdita_ast_3 = require("@evolvedbinary/lwdita-ast");
function createNode(node) {
    let nodeObject;
    /**
     * @example
     * `node`is an object containing the node name, its attributes, and their values.
     * ```json
     * {
     *   name: 'topic',
     *   attributes: [Object: null prototype] {},
     *   ns: [Object: null prototype] {},
     *   prefix: '',
     *   local: 'topic',
     *   uri: '',
     *   isSelfClosing: false
     * }
     * ```
     * If the node is a text node, it will simply contain its string content.
     */
    if (typeof node === 'string') {
        nodeObject = new lwdita_ast_2.TextNode(node);
    }
    else {
        const classType = (0, lwdita_ast_1.getNodeClass)(node.name);
        return new classType(node.attributes);
    }
    return nodeObject;
}
function createCDataSectionNode(cdata) {
    return new lwdita_ast_3.CDataNode(cdata);
}
//# sourceMappingURL=factory.js.map